export enum LOCATION_TYPE {
  AIRPORT = 'Airport',
  STANDARD = 'Standard',
  SEAPORT = 'Seaport',
  HOT_ZONE = 'HotZone',
  SAFE_ZONE = 'SafeZone',
  DANGER_ZONE = 'DangerZone',
  OPEN_MIC_ZONE = 'OpenMicZone',
  LOW_COVERAGE_ZONE='LowCoverageZone',
  //Asset manager location types
  CUSTOMER = 'Customer',
  DEPOT = 'Depot',
  DISTRIBUTION_CENTER = 'DistributionCenter',
  FULFILLMENT_CENTER = 'FulfillmentCenter',
  OUTSIDE_STORAGE = 'OutsideStorage',
  VENDOR = 'Vendor',
  // eBOL manager
  EBOL = 'Ebol',
}
